<template>
  <header>
      <div class="header-left">
          <div class="time" v-if="this.$route.path=='/BigScreen'">{{time}}</div>
          <div class="daysecond" v-if="this.$route.path=='/BigScreen'">
              <div class="second">{{second}}</div>
              <div class="day">{{day}}</div>
          </div>
        <slot name="left"></slot>
      </div>
      <div class="header-center">
          <div class="bg-title" v-if="this.$route.path=='/BigScreen'">起重机械生产企业安全智能综合监管平台</div>
          <div class="sm-title" v-if="this.$route.path=='/BigScreen'">Construction Machinery Enterprise Intelligent Comprehensive Supervision Platform</div>
        <slot name="center"></slot>
      </div>
      <div class="header-right">
          <i class="iconfont1" @click="buttoncli" :title="isFullscreen?'退出全屏':'进入全屏'">{{isFullscreen?'&#xe605;':'&#xe604;'}}</i>
          <i class="iconfont2" v-if="user.systemRole != 7" @click="$router.push('/Index')" title="进入后台">&#xe607;</i>
          <i class="iconfont3" v-if="this.$route.path!='/BigScreen'" @click="goback" title="返回上页">&#xe606;</i>
          <i class="iconfont4" v-if="this.$route.path=='/BigScreen'" @click="goback" title="退出登录">&#xe60f;</i>
      </div>
  </header>
</template>

<script>
export default {
    name: 'bigScreenHead',
    data(){
        return{
            isFullscreen: false,
            imgSrc: require('../assets/images/quanping.webp'),
            timer: 1,
            time: '',
            second: '',
            day: '',
            user: {},
            rlen:history.length,
        }
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    methods:{
        goback(){
            if(this.$route.path=='/BigScreen'){
                this.$router.push('/Login')
            }else if(this.$route.path=='/TowerBigScreen' || this.$route.path=='/LifterBigScreen'){
                let len = this.rlen - history.length - 1;//-1是不进入iframe页面的下级页面直接退出的话，执行后退一步的操作
                this.$router.go(len);
            }else{
                this.$router.go(-1)
            }
        },
        buttoncli(){
            this.$screenfull.toggle()
            this.checkFull()
        },
        // 监控屏幕变化
        checkFull() {
            var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
            this.isFullscreen = !this.isFullscreen;
            if(this.isFullscreen){
                this.imgSrc = require('../assets/images/suoxiao.webp')
            }else{
                this.imgSrc = require('../assets/images/quanping.webp')
            }
            if (isFull === undefined) {
                isFull = false;
            }
            return isFull;
        },
        //时间定时器
        getTime(){
            var dateTime=new Date();
            //获得系统年份;
            var year=dateTime.getFullYear();
            //获得系统月份;
            var month=dateTime.getMonth() + 1;
            //获得系统当月分天数;
            var day=dateTime.getDate();
            //获得系统小时;
            var hours=dateTime.getHours();
            //获得系统分钟;
            var minutes=dateTime.getMinutes();
            //获得系统秒数;
            var second=dateTime.getSeconds(); 
            //获得系统星期几;
            var dayCycle=dateTime.getDay();
            //使用数组更改日期样式;
            var dayCycleArray=["日","一","二","三","四","五","六"];
            for(var i=0;i<7;i++){
                if(dayCycle==i){
                //将dayCycleArray的数赋值到系统星期几里面中去;
                    dayCycle=dayCycleArray[i];
                }
            }
            month < 10 ? month='0'+month : month; 
            hours < 10 ? hours='0'+hours : hours; 
            minutes < 10 ? minutes='0'+minutes : minutes; 
            second < 10 ? second='0'+second : second;
            day < 10 ? day='0'+day : day
            this.second = hours + ':' + minutes + ':' + second;
            this.time = year + '-' + month + '-' + day;
            this.day = '星期' + dayCycle;
        }
    },
    mounted(){
        clearInterval(this.timer);
        this.getTime();
        this.timer = setInterval( () => {
             this.getTime();
        }, 1000);
       
    },
     destroyed() {
        clearInterval(this.timer);
    },
}
</script>

<style lang='scss' scoped>
.iconfont1{
    font-family:"iconfont" !important;
    font-size: 27px;
    font-style: normal;
    color: #fff;
    cursor: pointer;
    margin-right: 20px;
}
.iconfont2{
    font-family:"iconfont" !important;
    font-size: 27px;
    font-style: normal;
    color: #fff;
    cursor: pointer;
    margin-right: 20px;
}
.iconfont3{
    font-family:"iconfont" !important;
    font-size: 23px;
    font-style: normal;
    color: #fff;
    margin-right: 20px;
    cursor: pointer;
}
.iconfont4{
    font-family:"iconfont" !important;
    font-size: 27px;
    font-style: normal;
    color: #fff;
    margin-right: 20px;
    cursor: pointer;
}
header{
    height: 6%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    color: #fff;
}
.header-left{
    padding-left: 0.6%;
    font-size: 0.9rem;
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.header-center{
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.header-right{
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
img{
    margin: .5rem;
    margin-right: 0.7rem;
    cursor: pointer;
}
.time{
    height: 40%;
    width: 30%;
    text-align: center;
    white-space: nowrap;
}
.daysecond{
    color: #EDB942;
    height: 40%;
    width: 30%;
    display: flex;
    justify-content: space-around;
    white-space: nowrap;
}
.bg-title{
    font-size: 25px;
    font-weight: 600;
    letter-spacing: 4px;
    white-space: nowrap;
}
.sm-title{
    font-size: 13px;
}
</style>